import { render, staticRenderFns } from "./PopTextarea.vue?vue&type=template&id=6974f660&scoped=true&"
import script from "./PopTextarea.vue?vue&type=script&lang=js&"
export * from "./PopTextarea.vue?vue&type=script&lang=js&"
import style0 from "./PopTextarea.vue?vue&type=style&index=0&id=6974f660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974f660",
  null
  
)

export default component.exports